export const ADD_TO_BASKET_CTA = 'Add to basket';
export const BUY_GIFT_CARD_CTA = 'Buy giftcard';
export const EDIT_PERSONALISATION_CTA = 'Save changes';
